// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__2wRo9","options":"AnswerScale_options__18REg","selected":"AnswerScale_selected__VZKFZ"};